import CryptoJS from "crypto-js";
import store from "@/store/index";

const HASH_SALT = process.env.VUE_APP_NID_ENCRYPT_KEY;
const UNHASHED_ACCESS_USER = "mp940105";

export const hashText = (value) => {
  if (!value) return value;
  if (store.getters["userAuth/getUserID"] !== UNHASHED_ACCESS_USER) return value;
  return CryptoJS.SHA256(`${HASH_SALT}${value}`).toString();
};
